import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import Header from "./components/Header";
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import SoftwareDevelopment from './pages/SoftwareDevelopment';
import CustomSoftwareDevelopment from './pages/SoftwareDevelopment/CustomSoftwareDevelopment';
import EnterpriseMobileApplications from './pages/SoftwareDevelopment/EnterpriseMobileApplications';
import OnlineCollaborationPlatforms from './pages/SoftwareDevelopment/OnlineCollaborationPlatforms';
import DigitalLearningSolutions from './pages/SoftwareDevelopment/DigitalLearningSolutions';
import WebsiteDesign from './pages/WebsiteDesign';
import WordPressWebsiteDevelopment from './pages/WebsiteDesign/WordPressWebsiteDevelopment';
import CorporateWebsiteDevelopment from './pages/WebsiteDesign/CorporateWebsiteDevelopment';
import EcommerceWebsiteDevelopment from './pages/WebsiteDesign/EcommerceWebsiteDevelopment';
import WebsiteHostingAndSupport from './pages/WebsiteDesign/WebsiteHostingAndSupport ';
import DigitalMarketing from './pages/DigitalMarketing';
import SearchEngineOptimization from './pages/DigitalMarketing/SearchEngineOptimization';
import SearchEngineMarketing from './pages/DigitalMarketing/SearchEngineMarketing';
import ContentMarketing from './pages/DigitalMarketing/ContentMarketing';
import SocialMediaMarketing from './pages/DigitalMarketing/SocialMediaMarketing';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
<>
      <ScrollToTop />
    <div className="flex flex-col min-h-screen font-sans">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/software-development" element={<SoftwareDevelopment />} />
          <Route path="/software-development/custom-software-development" element={<CustomSoftwareDevelopment />} />
          <Route path="/software-development/enterprise-mobile-applications"  element={<EnterpriseMobileApplications />}/>
          <Route path="/software-development/online-collaboration-platforms"  element={<OnlineCollaborationPlatforms />}/>
          <Route path="/software-development/digital-learning-solutions"  element={<DigitalLearningSolutions />}/>
           <Route path="/website-design"  element={<WebsiteDesign />}/>
          <Route path="/website-design/wordpress-website-development"  element={<WordPressWebsiteDevelopment />}/>
           <Route path="/website-design/corporate-website-development"  element={<CorporateWebsiteDevelopment />}/>
          <Route path="/website-design/ecommerce-website-development"  element={<EcommerceWebsiteDevelopment />}/>
           <Route path="/website-design/website-hosting-support"  element={<WebsiteHostingAndSupport />}/>
            <Route path="/digital-marketing"  element={<DigitalMarketing />}/>
             <Route path="/digital-marketing/search-engine-optimisation-seo"  element={<SearchEngineOptimization />}/>
              <Route path="/digital-marketing/search-engine-marketing-sem"  element={<SearchEngineMarketing />}/>
               <Route path="/digital-marketing/content-marketing"  element={<ContentMarketing />}/>
                <Route path="/digital-marketing/social-media-marketing-smm"  element={<SocialMediaMarketing />}/>
        </Routes>
       
      </main>
      <Footer />

    </div>
 </>
  );
}

export default App;
